import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button, Input } from "antd";
import Select from "react-select";
import { TiUser } from "react-icons/ti";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import { initFilterInput, renderColumns } from "./constants";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import CustomTable from "../../../components/common/Table/CustomTable";
import Title from "../../../components/common/Title/Title";
import moment from "moment";
import DatePicker from "react-datepicker";
import { IoCalendarOutline } from "react-icons/io5";
import { convertJemputGadai } from "../helpers/convertJemputGadai";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import CustomDatePicker from "../helpers/CustomDatePicker";
import { GetImage } from "../../../components/helpers/GetImage";

export default function Jabatan() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [id, setId] = useState();
  const [dateValue, setDateValue] = useState([]);
  const [modalAdd, setMoadalAdd] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});
  const [codeGadai, setCodeGadai] = useState();
  const [namaNasabah, setNamaNasabah] = useState();
  const [notelpNasabah, setNotelpNasabah] = useState();
  const [kondisi, setKondisi] = useState();
  const [noImei, setNoImei] = useState();
  const [tanggalJemput, setTanggalJemput] = useState();
  const [waktuJemput, setWaktuJemput] = useState();
  const [alamatJemput, setAlamatJemput] = useState();
  const [kurir, setKurir] = useState({});
  const [barangJaminan, setBarangJaminan] = useState();
  const [image, setImage] = useState([]);
  const [date, setDate] = useState();
  const [alamat, setAlamat] = useState();
  const [kurirList, setKurirList] = useState([]);
  const [alasan, setAlasan] = useState();
  const [cancel, setCancel] = useState();

  useEffect(() => {
    getData();
    getKurir();
  }, [filterInput]);

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up`;
    let params = {
      search: filterInput.searchName,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize) || 1,
      start_date: filterInput.transactionStartDate,
      end_date: filterInput.transactionEndDate,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        let data = response.data.data;
        setRecords(convertJemputGadai(data.items));
        setTotalRecords(data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const reset = () => {
    // setKurir(0);
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: parseInt(value),
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  const handleSubmit = () => {
    setSubmitting(true);

    let data = {
      gadai_id: id,
      employee_id: kurir?.id,
      address: alamat,
      pick_up_date: date,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/confirm`;
    httpclient
      .POST(url, data)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        getData();
        setMoadalAdd(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleEdit = (record) => {
    setMoadalAdd(true);
    setDate(new Date(record.tanggal_jemput_submit));
    // setPickUpDate(record.tanggal_jemput_submit);
    setAlamat(record.alamat);
    setKurir(record.kode_kurir);
    // setOutletName(record.outlet_name);
    setId(record.kode_gadai);
  };

  const handleCancel = () => {
    setCancel(true);
    let data = {
      gadai_id: id,
      notes: alasan,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/decline`;
    httpclient
      .POST(url, data)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        getData();
        setModalCancel(false);
      })
      .catch((error) => {
        if (error.response) {
          setCancel(false);
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
          setCancel(false);
        }
      });
  };

  const handleDetail = (record) => {
    setModalDetail(true);
    setCodeGadai(record.kode_gadai);
    setNamaNasabah(record.nama_nasabah);
    setNotelpNasabah(record.no_telp);
    setBarangJaminan(convertBarangName(record.barang_jaminan));
    setWaktuJemput(record.waktu_jemput);
    setAlamatJemput(record.lokasi_jemput);
    setKurir(record.name_kurir);
    setTanggalJemput(record.tanggal_jemput_detail);
    setImage(record.gadai_picture);
  };

  const convertBarangName = (item) => {
    if (item === "smartphone") {
      return "Smartphone";
    } else if (item === "bike") {
      return "Sepeda Motor";
    } else if (item === "car") {
      return "Mobil";
    } else if (item === "bpkb") {
      return "BPKB";
    }
  };

  const handleCloseModal = () => {
    // setSubmitting(false);
    setModalEditUser(false);
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
      // sortingField: sorter?.column?.backend_key || null,
      // sortingOrder: "descend"
    }));
  };

  const getKurir = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/master-data`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setKurirList(
          response.data.data.couriers.map((item) => ({
            value: item.id,
            label: `${item.first_name} ${item.last_name}`,
            outlet: item.outlet.name,
            // ...item,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleSelectKurir = (e) => {
    setKurir({
      id: e.value,
      outlet: e.outlet,
    });
  };

  return (
    <>
      <div>
        <div className="p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Title text="Jadwal Jemput Gadai" />
              <Breadcrumb current="Jadwal Jemput Gadai" />
            </div>

            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 200,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{totalRecords}</span> jadwal
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 mt-2">
            <div className="col-1 pl-0">
              <div>Tampilkan</div>
              <input
                type="number"
                className="form-control border-A6A6A6 mt-1"
                name="pageSize"
                value={filterInput.pageSize}
                onChange={handleFilterChanged}
              />
            </div>
            <div className="mr-3">
              <div>Nama Nasabah</div>
              <input
                type="text"
                name="name"
                className="form-control border-A6A6A6 mt-1"
                placeholder="Cari"
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div className="">
              <CustomDatePicker
                id={"TanggalJemput"}
                label={"Tanggal Jemput"}
                isRangePicker
                width="60%"
                onInputChange={handleDateChange}
                value={dateValue}
                height="35px"
              />
            </div>
          </div>
          <div className="mt-3">
            <CustomTable
              columns={renderColumns(handleEdit, handleDetail)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
              scrollX={1800}
            />
          </div>
        </div>
      </div>
      {/* Modal Konfirmasi Jadwal */}
      <Modal
        centered
        title="Konfirmasi Kurir"
        className="modal-form"
        visible={modalAdd}
        onCancel={() => {
          setMoadalAdd(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalCancel(true);
              setMoadalAdd(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "red",
            }}
          >
            Batalkan
          </Button>,
          <Button
            onClick={() => {
              setMoadalAdd(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Kirim
          </Button>,
        ]}
      >
        <div>
          <form>
            <div className="row form-group align-items-center">
              <div className="col-4">
                <label>Tanggal Jemput :</label>
              </div>

              <div className="col-8">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  onChange={(date) => setDate(date)}
                  className="form-control"
                />
                <IoCalendarOutline
                  style={{ fontSize: 30, marginLeft: -50, zIndex: 1 }}
                />
              </div>
            </div>
            <div className="row form-group align-items-center">
              <div className="col-4">
                <label>Waktu Jemput :</label>
              </div>
              <div className="col-8">
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="HH:mm"
                  className="form-control"
                />
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Alamat :</label>
              </div>
              <div className="col-8">
                <Input.TextArea
                  required
                  rows="6"
                  type="text"
                  className="form-control border-DCDCDC text-input"
                  placeholder="Alamat outlet"
                  defaultValue={alamat}
                  value={alamat}
                  onChange={(e) => setAlamat(e.target.value)}
                />
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Kurir :</label>
              </div>
              <div className="col-8">
                <Select
                  name="kurir"
                  options={kurirList}
                  onChange={(e) => handleSelectKurir(e)}
                  value={kurirList.find((e) => e.value == kurir?.id) || ""}
                />
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Outlet :</label>
              </div>
              <div className="col-8">
                <p className="">{kurir?.outlet}</p>
              </div>
            </div>
          </form>
        </div>
      </Modal>
      {/* Modal Batalkan proses gadai */}
      <Modal
        centered
        className="modal-form"
        title="Batalkan Proses Gadai"
        visible={modalCancel}
        onCancel={() => {
          setModalCancel(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalCancel(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            onClick={() => {
              handleCancel();
              setModalCancel(false);
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "red",
            }}
          >
            Batalkan
          </Button>,
        ]}
      >
        <div>
          <form>
            <div className="form-group">
              <label>Berikan Alasan :</label>
              <Input.TextArea
                required
                rows="6"
                type="text"
                className="form-control border-DCDCDC text-input"
                placeholder="Alamat outlet"
                defaultValue={alasan}
                value={alasan}
                onChange={(e) => setAlasan(e.target.value)}
              />
            </div>
          </form>
        </div>
      </Modal>

      {/* Modal Detail Jemput Gadai */}
      <Modal
        className="modal-detail"
        title="Detail Jemput Gadai"
        visible={modalDetail}
        onCancel={() => {
          setModalDetail(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalDetail(false);
              reset();
            }}
            style={{
              border: "0.75px solid #2C465C",
              borderRadius: 6,
              width: 120,
              height: 35,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={() => {
              setModalDetail(false);
              setMoadalAdd(true);
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 150,
              height: 35,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Konfirmasi Jadwal
          </Button>,
        ]}
      >
        <div>
          <div
            className="row flex-row flex-nowrap"
            style={{ overflow: "auto", width: "500px" }}
          >
            {image.map((item) => (
              <GetImage
                className="rounded mb-2 mr-2"
                url={`gadai-product-picture/${item.id}/picture`}
                style={{ width: "200px" }}
              />
            ))}
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Kode Gadai" value={codeGadai || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Nama Nasabah" value={namaNasabah || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="No. Telepon Nasabah"
              value={notelpNasabah || "-"}
            />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Barang Jaminan" value={barangJaminan || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Kondisi" value={kondisi || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="No. IMEI" value={noImei || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Tanggal Jemput" value={tanggalJemput || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Waktu Jemput" value={waktuJemput || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Alamat Jemput" value={alamatJemput || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Kurir" value={kurir || "-"} />
          </div>
        </div>
      </Modal>
    </>
  );
}
